import { CLEAN_DETAIL_LIST_SIM_IPB, CLEAN_DETAIL_LIST_SIM_IPB_ERROR } from '_models/redux/types';

export const cleanDetailListSimIpbAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_LIST_SIM_IPB,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_LIST_SIM_IPB_ERROR,
    });
  }
};
